import { render, staticRenderFns } from "./BarsBody.vue?vue&type=template&id=51e99bb6&"
import script from "./BarsBody.vue?vue&type=script&lang=js&"
export * from "./BarsBody.vue?vue&type=script&lang=js&"
import style0 from "./BarsBody.vue?vue&type=style&index=0&id=51e99bb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports